import styled from "styled-components";

export const StyledSocialList = styled.ul`
  background-color: #4a1a2b;
  border-radius: 5px 5px 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style: none;
  transition: all 0.3s ease-out;

  &:after {
    content: "";
    display: block;
    width: 1px;
    height: 90px;
    margin: 0 auto;
    background-color: #4e878c;
    transition: height 0.3s ease-out;
  }

  li {
    margin-bottom: 15px;

    &:last-of-type {
      margin-bottom: 20px;
    }

    a {
      padding: 10px;
      display: inline-block;
      transition: transform 0.3s ease-out;

      &:hover,
      &:focus {
        transform: translateY(-5px);
        color: #4e878c;
      }

      svg {
        width: 20px;
        height: 20px;
        color: #4e878c;
        transition: transform 0.3s ease-out;
      }
    }
  }
`;
